import { Observable } from '@jkhy/frontend-utils/observable';
import { asyncNoOp, noOp } from '@treasury/utils';
import { IRealtimeService } from './realtime.service.types';

export const NullRealtimeService: IRealtimeService = {
    connected$: new Observable(),
    init: asyncNoOp,
    disconnect: asyncNoOp,
    subscribe: () => Promise.resolve({ unsubscribe: noOp }),
    publish: () => Promise.resolve(),
};
